
































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Shop, Address } from "../../api/types";

@Component({
  name: "ShopInfo"
})
export default class extends Vue {
  @Prop() private shop!: Shop;

  /** Defer heavy Maps embed until after first paint / when near viewport */
  private mapSrc: string | null = null;
  private mapLoadTimer: number | null = null;

  private days = [
    {
      key: "monday",
      text: "Monday"
    },
    {
      key: "tuesday",
      text: "Tuesday"
    },
    {
      key: "wednesday",
      text: "Wednesday"
    },
    {
      key: "thursday",
      text: "Thursday"
    },
    {
      key: "friday",
      text: "Friday"
    },
    {
      key: "saturday",
      text: "Saturday"
    },
    {
      key: "sunday",
      text: "Sunday"
    }
  ];

  get displayedAddress(): string {
    const {
      line1,
      line2,
      line3,
      district,
      region,
      postcode
    }: Address = this.shop.address;
    const addressDetails = [line1, line2, line3, district, region, postcode];
    const addressDetailsNotNull = addressDetails.filter(Boolean);
    return addressDetailsNotNull.join(", ");
  }

  get contactNumberHref() {
    const { contactNumber } = this.shop;
    return contactNumber && `tel:${contactNumber}`;
  }

  get contactEmailHref() {
    const { contactEmail } = this.shop;
    return contactEmail && `mailto:${contactEmail}`;
  }

  mounted() {
    this.scheduleMapLoad();
  }

  beforeDestroy() {
    if (this.mapLoadTimer != null) {
      window.clearTimeout(this.mapLoadTimer);
    }
  }

  private scheduleMapLoad() {
    const url = this.shop.googleMapsUrl;
    if (!url || this.mapSrc === url) return;

    // Idle callback when available; otherwise a short delay so shop UI paints first
    const load = () => {
      this.mapSrc = this.shop.googleMapsUrl || null;
    };

    const win = window as Window & {
      requestIdleCallback?: (
        callback: () => void,
        options?: { timeout: number }
      ) => number;
    };

    if (typeof win.requestIdleCallback === "function") {
      win.requestIdleCallback(load, { timeout: 2000 });
    } else {
      this.mapLoadTimer = window.setTimeout(load, 400);
    }
  }
}
